import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './index.css';
import Notifications from "./pages/notifications/Notifications";
import Help from "./pages/help/Help";
import Settings from "./pages/settings/Settings";
import Parts from "./pages/parts/Parts";
import Tests from "./pages/tests/Tests";
import Plans from "./pages/plans/Plans";
import Tasks from "./pages/tasks/Tasks";
import Protocol from "./pages/protocol/Protocol";
import Evaluation from "./pages/evaluation/Evaluation";
import Support from "./pages/support/Support";
import Auth from "./pages/auth/Auth";
import {authHandler} from "./services/auth";

authHandler();
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const router = createBrowserRouter([
    {
        path: "/",
        element: <Tests />,
    },
    {
        path: "/auth",
        element: <Auth />,
    },
    {
        path: "/notifications",
        element: <Notifications />,
    },
    {
        path: "/help",
        element: <Help />,
    },
    {
        path: "/settings",
        element: <Settings />,
    },
    {
        path: "/parts",
        element: <Parts />,
    },
    {
        path: "/tasks",
        element: <Tasks />,
    },
    {
        path: "/plans",
        element: <Plans />,
    },
    {
        path: "/protocol",
        element: <Protocol />,
    },
    {
        path: "/evaluation",
        element: <Evaluation />,
    },
    {
        path: "/support",
        element: <Support />,
    },
]);

root.render(
  <React.StrictMode>
      <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();